const Vue = require('vue')

module.exports = new Vue({
    data () {
        return {
            errors: {}
        }
    },
    methods: {
        profile () {
            if (!this.$matrix) {
                return Promise.reject(new Error('$matrix is not set, check if there is `bus-road` on root'))
            }

            return this.$matrix.then(({ profile }) => {
                return profile
            })
        },
        putErrors (formName, errors) {
            this.errors[formName] = errors
            this.$emit('errors', { formName, errors })
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/std/bus.js